var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14 6a.5.5 0 0 1 .366.16l6.5 7a.5.5 0 0 1 .134.34v8a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V18h-2v3.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .134-.34l6.5-7A.5.5 0 0 1 14 6Zm-6 7.696V21h4v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V21h4v-7.304l-6-6.461-6 6.461Z",
  clipRule: "evenodd"
})));
export { SvgHome28 as ReactComponent };
export default __webpack_public_path__ + "eeeda56c25ad7f9d8f2e106167f47307.svg";